export function getMessageFromResponse (err) {
  if (err?.response?.data?.fullErrorMessage || err?.response?.data?.message) {
    return err?.response?.data?.fullErrorMessage || err?.response?.data?.message
  } else {
    return err?.message
  }
}
